var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('CustomButton',{attrs:{"text":_vm.secondaryBtnText,"isSecondary":true,"icon":_vm.secondaryIcon},on:{"onClick":function($event){return _vm.$emit('secondaryClicked')}}}),_vm._v(" "),_c('CustomButton',{attrs:{"text":_vm.primaryBtnText,"icon":_vm.primaryIcon},on:{"onClick":function($event){return _vm.$emit('primaryClicked')}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ec6bd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/utils/buttons/ButtonGroup.vue
// module id = null
// module chunks = 